import React from 'react';
import {
  Row,
  Col,
  Divider,
  Input,
  Typography,
  Table,
  Space,
  Skeleton,
  Result
} from 'antd'
// import {
//   PlusOutlined
// } from '@ant-design/icons';
import DeletePopupButton from './components/DeletePopupButton';
import EditFormModal from './components/EditFormModal';
import AddFormModal from './components/AddFormModal';
import { useQuery } from '@tanstack/react-query';

const columns = [
  {
    title: 'ชื่อ',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'ที่อยู่',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: 'ตำบล',
    dataIndex: 'sub_district',
    key: 'sub_district',
  },
  {
    title: 'อำเภอ',
    dataIndex: 'district',
    key: 'district',
  },
  {
    title: 'จังหวัด',
    dataIndex: 'province',
    key: 'province',
  },
  {
    title: 'รหัสไปรษณีย์',
    dataIndex: 'postalcode',
    key: 'postalcode',
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <EditFormModal data={record} />
        <DeletePopupButton data={record} />
      </Space>
    ),
  }
]

function List() {

  const { isLoading, isError, error, data } = useQuery({ queryKey: ['/api/warehouse'] })


  const onSearch = e => {
    console.log('onSearch :', e);
  }

  if (isLoading) {
    return <Skeleton active />
  }

  if (isError) {
    return <Result status="error" title={error.message} />
  };


  // console.log(data);
  return (
    <div style={{
      background: '#fff',
    }}>

      <Row justify='space-between' >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            รายการคลังสินค้า
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row justify="end">
            <Col>
              <AddFormModal />
            </Col>
          </Row>
        </Col>
        <Divider />
        <Col xs={24} >
          <Row justify='space-between' gutter={[0, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Input.Search
                placeholder="ค้นหาตามรายชื่อ"
                onSearch={onSearch}
                enterButton
                style={{ width: '100%' }}
              />
            </Col>
            <Col xs={24}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={data}
                scroll={{
                  x: 1200,
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default List